import Badge, { DangerBadge, SuccessBadge } from './template';
export default Badge;
export { DangerBadge, SuccessBadge };
